import "../../../assets/scss/DataGrid.scss";
import { Button, Col, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";

import { capitalizeWord } from "../../../_helpers/stringHelper";
import { pagination } from "../../../_helpers/tableHelper";
import GridActionButtons from "../../../common/components/GridActionButtons";
import Loader from "../../../common/components/Loader";
import PaginationComponent from "../../../common/components/PaginationComponent";
import SearchBarre from "../../../common/components/searchBarre/SearchBarre";
import { GridType } from "../../../common/enums/sharedEnums.ts";
import history from "../../../routes/history";
import { IBuilding } from "../reducers";
import { BUILDING_DETAILS, NEW_BUILDING, UPDATE_BUILDING } from "../routes";

export interface BuildingDataGridProps {
  activePage: number;
  buildings: IBuilding[];
  buildingsNb: number;
  noMenu?: any; //add to remove the search and import tools
  setActivePage: React.Dispatch<React.SetStateAction<number>>;
  states: any;
  loading: boolean;
}

export const getResidenceName = (building: IBuilding) => {
  const residenceName: string[] = [];
  if (building.cadastralReference)
    residenceName.push(building.cadastralReference);
  if (building.address.residenceName)
    residenceName.push(capitalizeWord(building.address.residenceName));
  return residenceName.join(" - ");
};

const BuildingDataGridComponent = ({
  buildings,
  buildingsNb,
  activePage,
  setActivePage,
  noMenu,
  states,
  loading,
}: BuildingDataGridProps) => {
  return (
    <div className="d-flex flex-column gap-3">
      {noMenu === undefined && (
        <Row className=" align-items-center">
          <Col lg={7} className=" align-items-center d-flex">
            <SearchBarre
              disabled={loading}
              setSearchValue={(value) => {
                setActivePage(1);
                states.setInputFilter(value);
              }}
              placeholder="Rechercher ..."
            />
          </Col>

          <Col lg={{ span: 3, offset: 2 }} className=" align-items-center">
            <div className="d-flex justify-content-lg-end flex-grow-1 gap-3">
              {/*NOT FOR THE MVP*/}
              {/*<Button*/}
              {/*  className="archive-btn d-flex align-items-center justify-content-center w-100 flex-grow-1"*/}
              {/*  variant="primary"*/}
              {/*>*/}
              {/*  <i style={{ fontSize: '18px' }} className="bi bi-geo-alt me-3 me-lg-2"></i>*/}
              {/*  Cartographie*/}
              {/*</Button>*/}
              <Link to={NEW_BUILDING}>
                <Button type="button" variant="success" className="btn-add-new">
                  <i className="bi bi-plus" />
                  Ajouter un immeuble
                </Button>
              </Link>
            </div>
          </Col>
        </Row>
      )}

      <div className="datagridTable p-2">
        <Table borderless responsive className="datagridTable">
          <thead>
            <tr className="orders-gird-header">
              <th>Réf.</th>
              <th>Agence</th>
              <th>Bailleur</th>
              <th>Nom résidence/programme</th>
              <th>Adresse</th>
              <th>NB de Lots</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6}>
                  <Loader />
                </td>
              </tr>
            ) : buildings && buildings.length > 0 ? (
              <>
                {buildings.map((building) => {
                  return undefined !== building.id ? (
                    <tr
                      key={building.internalReference}
                      className="orders-tr"
                      onClick={() =>
                        history.push(
                          BUILDING_DETAILS.replace(
                            ":id",
                            building.datedReference || building.id || "",
                          ),
                        )
                      }
                    >
                      <td className="gray-td">{building.datedReference}</td>
                      <td className="gray-td">{building.agency.label}</td>
                      <td className="gray-td">
                        {capitalizeWord(building.lessorName || "")}
                      </td>
                      <td>
                        <Link
                          to={BUILDING_DETAILS.replace(
                            ":id",
                            building.datedReference || building.id,
                          )}
                          className="propertyAdressLink  link-td text-center d-flex flex-row justify-content-center gap-2"
                        >
                          {getResidenceName(building)}
                        </Link>
                      </td>
                      <td className="gray-td">
                        {building.address.address}, {building.address.zip}{" "}
                        {building.address.city}
                      </td>
                      <td className="gray-td">
                        {building.managementLotNumber}
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <GridActionButtons
                            viewUrl={BUILDING_DETAILS.replace(
                              ":id",
                              building.datedReference || building.id || "",
                            )}
                            editUrl={UPDATE_BUILDING.replace(
                              ":id",
                              building.datedReference || building.id || "",
                            )}
                            type={GridType.building}
                          />
                        </div>
                      </td>
                    </tr>
                  ) : null;
                })}
              </>
            ) : (
              <>
                <p className="p-no-property mt-3 ms-2">
                  Aucun immeuble disponible.
                </p>
              </>
            )}
          </tbody>
        </Table>
      </div>

      <div className="navigationButtonWrapper">
        <PaginationComponent
          pages={pagination(buildingsNb)}
          activePage={activePage}
          setActivePage={setActivePage}
          disabled={loading}
        />
      </div>
    </div>
  );
};

export default BuildingDataGridComponent;
